<div>
  <div *ngIf="!!selectedManuscript" class="details-container" [ngClass]="{'en': currentLang === 'en'}" role="region"
    [attr.aria-label]="'iaa.app.manuscript.manuscriptDetails' | translate">

    <div class="site-info" *ngIf="selectedManuscript.manuscriptCompositions?.length">
      <div class="site">
        <div class="detail-label">{{'iaa.app.manuscript.site' | translate}}</div>
        <div class="detail-value">{{ getTranslatedValue(selectedManuscript.manuscriptCompositions[0]?.site) }}
        </div>
      </div>
    </div>

    <div class="content-container">
      <div class="flex flex-column col-8 composition-section-wrapper">
        <div class="compositions-section">
          <div class="section-header">
            <div class="section-title-container" (click)="toggleCompositionsSection()" style="cursor:pointer;" 
                 [attr.aria-expanded]="compositionsSectionOpen">
              <div class="section-title">
                {{'iaa.app.manuscript.compositionsInManuscript' | translate}}
                ({{selectedManuscript.manuscriptCompositions?.length || 0}})
              </div>
              <div class="section-icons">
                <i class="pi pi-chevron-down icon-expanded" [class.section-collapsed]="!compositionsSectionOpen"></i>
              </div>
            </div>
            <div class="composition-toggle-container">
              <p-inputSwitch inputId="details-switch"  [ngModel]="showAllCompositionDetails" (onChange)="toggleAllCompositionDetails()"/>
              <label for="details-switch" class="toggle-label">{{'iaa.app.manuscript.fullDetails' | translate}}</label>
            </div>
          </div>
          <details class="compositions-details" [open]="compositionsSectionOpen">
            <summary>
              <span class="sr-only">{{'iaa.app.manuscript.compositionsInManuscript' | translate}}</span>
            </summary>

            <div class="compositions-content" *ngIf="!!selectedManuscript.manuscriptCompositions?.length">
              <div class="compositions-table">
                <table class="data-table">
                  <tbody>
                    <ng-container *ngFor="let composition of selectedManuscript.manuscriptCompositions; let i = index">
                      <tr class="composition-row" [class.composition-expanded]="isCompositionExpanded(i)">
                        <td class="composition-details-cell">
                          <div class="composition-name">
                            <div class="detail-item">
                              <div class="detail-label">{{'iaa.app.manuscript.composition' | translate}}</div>
                              <div class="detail-value">{{ getTranslatedValue(composition.compositionName) }}</div>
                            </div>
                          </div>
                        </td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.manuscriptType' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.manuscriptType) }}</div>
                          </div>
                        </td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.compositionType' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.compositionType) }}</div>
                          </div>
                        </td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.language' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.language) }}</div>
                          </div>
                        </td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.script' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.script) }}</div>
                          </div>
                        </td>
                        <td class="expand-cell expanded">
                          <button type="button" class="expand-button" (click)="toggleComposition(i)"
                            [class.expanded]="isCompositionExpanded(i)" [attr.aria-expanded]="isCompositionExpanded(i)"
                            [attr.aria-label]="'iaa.app.manuscript.toggleCompositionDetails' | translate">
                            <i class="pi pi-chevron-down icon-expanded"></i>
                          </button>
                        </td>
                      </tr>

                      <tr class="composition-details-row" *ngIf="isCompositionExpanded(i)">
                        <td class="composition-details-cell"></td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.period' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.period) }}</div>
                          </div>
                        </td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.material' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.material) }}</div>
                          </div>
                        </td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.summary' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.kitsurName) }}</div>
                          </div>
                        </td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.genre' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.genre) }}</div>
                          </div>
                        </td>
                        <td class="composition-details-cell">
                          <div class="detail-item">
                            <div class="detail-label">{{'iaa.app.manuscript.tipus' | translate}}</div>
                            <div class="detail-value">{{ getTranslatedValue(composition.tipus) }}</div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </details>
        </div>

        <div class="fragments-section" *ngIf="selectedManuscript.manuscriptFragments?.length">
          <div class="section-header">
            <div class="section-title-container" (click)="toggleFragmentsSection()" style="cursor:pointer;"
                 [attr.aria-expanded]="fragmentsSectionOpen">
              <div class="section-title">
                {{'iaa.app.manuscript.fragments' | translate}} ({{selectedManuscript.manuscriptFragments?.length || 0}})
              </div>
              <div class="section-icons">
                <i class="pi pi-chevron-down icon-expanded" [class.section-collapsed]="!fragmentsSectionOpen"></i>
              </div>
            </div>
          </div>
          <details class="fragments-details" [open]="fragmentsSectionOpen">
            <summary>
              <span class="sr-only">{{'iaa.app.manuscript.fragments' | translate}}</span>
            </summary>
            <div class="fragments-content">
              <div class="fragments-table scrollable-table">
                <table class="data-table fragments">
                  <thead>
                    <tr>
                      <th>{{'iaa.app.manuscript.fragTitle' | translate}}</th>
                      <th>{{'iaa.app.manuscript.fragment' | translate}}</th>
                      <th>{{'iaa.app.manuscript.plate' | translate}}</th>
                      <th>DJD</th>
                    </tr>
                  </thead>
                </table>
                <div class="table-body-wrapper">
                  <table class="data-table fragments">
                    <tbody>
                      <tr *ngFor="let fragment of sortedFragments; let last = last"
                        [class.fragment-row]="true" [class.fragment-row-last]="last"
                        [class.matched-fragment]="isFragmentMatched(fragment)">
                        <td class="frag-td">
                          <a class="custom-link" role="navigation" tabindex="0"
                             [appReturnFocus]="'fragments:' + fragment.entityId"
                             (click)="goToFragment(fragment.entityId);"
                             (keydown.enter)="goToFragment(fragment.entityId);">
                            {{ fragment.title }}
                            <!-- The highlight is visual only - tell screen readers too -->
                            <span class="sr-only" *ngIf="isFragmentMatched(fragment)">, {{ 'iaa.app.manuscript.fragmentMatchesSearch' | translate }}</span>
                          </a>
                        </td>
                        <td class="frag-td">{{ fragment.fragNum }}</td>
                        <td class="frag-td">{{ fragment.plateNum }}{{fragment.plateTatNum ? '/' + fragment.plateTatNum : '' }}</td>
                        <td class="frag-td">{{ fragment.djdNum }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </details>
        </div>

        <div class="fragments-section">
          <div class="section-header">
            <div class="section-title-container" (click)="toggleBibliographiesSection()" style="cursor:pointer;"
                 [attr.aria-expanded]="bibliographiesSectionOpen">
              <div class="section-title">
                {{'iaa.app.manuscript.bibliographies' | translate}}
                ({{selectedManuscript.manuscriptBibliographies?.length || 0}})
              </div>
              <div class="section-icons">
                <i class="pi pi-chevron-down icon-expanded" [class.section-collapsed]="!bibliographiesSectionOpen"></i>
              </div>
            </div>
          </div>
          <details class="fragments-details" [open]="bibliographiesSectionOpen">
            <summary>
              <span class="sr-only">{{'iaa.app.manuscript.bibliographies' | translate}}</span>
            </summary>
            <div class="bibliographies-section" *ngIf="selectedManuscript.manuscriptBibliographies?.length">
              <div class="bibliographies-content">
                <div class="detail-item bibliography" *ngFor="let bibliography of selectedManuscript.manuscriptBibliographies">
                  <div class="detail-value">{{ bibliography }}</div>
                </div>
              </div>
            </div>
          </details>
        </div>

        <div class="additional-bibliography-section" *ngIf="selectedManuscript.additionalManuscriptBibliography">
          <div class="section-header">
            <div class="section-title">
              {{'iaa.app.manuscript.additionalBibliography' | translate}}
            </div>
          </div>
          <div class="additional-bibliography-content">
            <div class="additional-bibliography-detail">
              <div
                *ngIf="selectedManuscript.additionalManuscriptBibliography && selectedManuscript.additionalManuscriptBibliography != '$'"
                class="detail-value">
                <a [href]="selectedManuscript.additionalManuscriptBibliography" target="_blank"
                  rel="noopener noreferrer" class="bibliography-link">
                  {{'iaa.app.manuscript.maagarim' | translate}}
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- description section   display manuscriptDescription for hebrew and manuscriptDescriptionEng for english -->
        <div class="description-section">
          <div class="section-header">
            <div class="section-title">
              {{'iaa.app.manuscript.manuscriptDescription' | translate}}
            </div>
          </div>
          <div class="description-content">
            <div class="description" [ngClass]="{ 'en': currentLang === 'en' }">
              {{
              currentLang === 'en'
              ? selectedManuscript.manuscriptDescriptionEng?.join(', ')
              : selectedManuscript.manuscriptDescription?.join(', ')
              }}
            </div>
          </div>

        </div>
      </div>

      <app-image-gallery *ngIf="images?.length" [images]="images" class="gallery"
        [objectName]="('iaa.app.manuscript.manuscriptNumber' | translate) + ' ' + selectedManuscript.manuscriptNumber">
      </app-image-gallery>
    </div>
  </div>
</div>